

interface H1TitleProps {
    children: React.ReactNode;
}


const H1Title: React.FC<H1TitleProps> = ({ children }) => {

    return (
        <div className='hc-text-align-center'>
            <div style={{ height: 1 }}></div>
            <div>
                <h1 className='hc-h1-main-title'>{children}</h1>
            </div>
            <div style={{ height: 1 }}></div>
        </div>
    )
}

export default H1Title